import { ModelAnswerSourceCodePresenter } from '@/presentation/presenters/modelAnswer/modelAnswerSourceCodePresenter'
import { ModelAnswerSourceCodeViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerSourceCodeViewModel'

export function useModelAnswerSourceCodePresenter(
  presenter: ModelAnswerSourceCodePresenter = new ModelAnswerSourceCodePresenter(new ModelAnswerSourceCodeViewModel())
) {
  return {
    modelAnswerSourceCodeList: presenter.modelAnswerSourceCodeList,
    loading: presenter.loading,
    error: presenter.error,
    fetchModelAnswerSourceCodeList: presenter.fetchModelAnswerSourceCodeList.bind(presenter)
  }
}
